module.exports = __webpack_public_path__ + "img/namina-forna.405e3df5.png";